import RequirementTypeEnumDTO from "features/requirements/dtos/RequirementTypeEnumDTO";

export enum RequirementTypesActionTypes {
  SET_REQUIREMENT_TYPES = "@@requirementTypes/SET_REQUIREMENT_TYPES"
}

export type RequirementTypesAction =
  | { type: RequirementTypesActionTypes.SET_REQUIREMENT_TYPES; data: RequirementTypeEnumDTO[] };

export const setRequirementTypes = (data: RequirementTypeEnumDTO[]): RequirementTypesAction => {
  return {
    type: RequirementTypesActionTypes.SET_REQUIREMENT_TYPES,
    data: data,
  };
};